import { useState } from 'react';
import Authentication from 'libs/authentication';
import API from 'libs/api';
import { useNavigate } from 'react-router-dom';
import { Button } from 'semantic-ui-react';
import { INPUT } from 'components/cmp_form/cmp_form';
import PROCESSING from 'components/cmp_processing/cmp_processing';
import MESSAGE from 'components/cmp_message/cmp_message';

import './crd_signin.css';



export default function CRD_SIGNIN() {

    const navigate = useNavigate();
    const [canProcess, setCanProcess] = useState(true);
    const [processing, setProcessing] = useState('inactive');
    const [message, setMessage] = useState({});
    const [signin, setSignin] = useState({});

    const showError = (text) => {
        setMessage({
            state: 'warning',
            header: 'There was a problem signing in',
            text
        });
        setProcessing('error');
    };

    async function authenticate() {
        try {
            setCanProcess(false);
            setProcessing('processing');

            const signinResult = await Authentication.sign_in(signin.email, signin.password);

            if (signinResult.challengeName === 'NEW_PASSWORD_REQUIRED') {
                await Authentication.password_new(signinResult, signin.password);
            }

            const authenticatedUser = await API_get_authenticateduser();

            if (authenticatedUser === 'NO ACTIVE ACCOUNT') {
                showError('An unexpected error occurred. Please try again.');
                await Authentication.sign_out();
                return;
            }

            sessionStorage.setItem('authenticated', 'true');
            navigate('/domains');
        } catch (error) {
            if (error.code === 'NotAuthorizedException' || error.code === 'UserNotFoundException') {
                showError("We couldn't find a match in our records for the email and password you entered. Please try again.");
            } else {
                showError('An unexpected error occurred. Please try again.');
            }

            sessionStorage.removeItem('authenticated');
        } finally {
            setCanProcess(true);
        }
    }

    function API_get_authenticateduser() {
        return API.get('admin', '/get-authenticateduser');
    }

    function onChange_input(event) {
        setSignin((currentSignin) => ({
            ...currentSignin,
            [event.target.name]: event.target.value
        }));
        setMessage({});
        setProcessing('inactive');
        setCanProcess(true);
    }

    function onClick_signin() {
        if (canProcess) {
            authenticate();
        }
    }

    return (
        <div id='mdl_signin' className='modal rounded-lg shadow-sm'>
            <div className='modal__header'>
                <div className='text--md medium'>Lively Village Admin</div>
            </div>

            <div className='modal__content'>

                <MESSAGE
                    header={message.header}
                    state={message.state}
                    text={message.text}
                />

                <div className='modal__content__instructions text--sm normal color--gray--600'>Enter your Lively Village administrative username and password.</div>

                <INPUT
                    errors={[]}
                    label='Email address'
                    name='email'
                    onChange={onChange_input}
                    placeholder='Email address'
                    value={signin.email || ''}
                />

                <INPUT
                    errors={[]}
                    label='Password'
                    name='password'
                    onChange={onChange_input}
                    placeholder='Password'
                    type='password'
                    value={signin.password || ''}
                />

            </div>

            <PROCESSING state={processing} />
            <div className='modal__footer'>
                <Button className={'primary' + (!canProcess ? ' inactive' : '')} onClick={onClick_signin}>SIGN IN</Button>
            </div>

        </div>
    );

}